import React from 'react';

import classes from './RoundCheckbox.css';

const roundCheckBox = (props) => {
  let price = props.price;
  let priceLayout = price ? <span className={[classes.PriceLabel, props.isChecked ? classes.ActiveLabel : ''].join(' ')}>/{props.price}</span> : null;
  return (
    <div className={classes.RoundCheckBox} onClick={() => props.clicked(props.id)} id={props.id}>
      <div className={classes.RoundRadioContainer}>
        <div className={classes.RoundRadio}>
          {props.isChecked ? <div className={classes.RadioSelected} /> : null}
        </div>
      </div>
      {/* <span className={[classes.MainLabel, props.isChecked ? classes.ActiveLabel : ''].join(' ')}>{props.name}</span>{priceLayout} */}
    </div>
  )
}

export default roundCheckBox;





// WEBPACK FOOTER //
// ./src/components/UI/Checkbox/RoundCheckbox/RoundCheckbox.js